export default __webpack_public_path__ + "static/media/desktopIcon.92473831.svg";